import {
  Component,
  ContentChildren,
  QueryList,
  TemplateRef,
  AfterContentInit,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { StepperService } from '../../services/stepper.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    standalone: false
})
export class StepperComponent implements AfterContentInit {
  @ContentChildren('step')
  stepsContent!: QueryList<TemplateRef<any>>;
  steps: { label: string; content: TemplateRef<any> }[] = [];
  @ContentChildren('button')
  buttonContent!: QueryList<TemplateRef<any>>;
  buttonLayout: { label: string; content: TemplateRef<any> }[] = [];
  title: { label: string; content: TemplateRef<any> } = {
    label: '',
    content: null!,
  };
  currentStep = 0;
  @Input() labels: any = [];
  @Input() offerType: string = '';
  @Input() editMode: boolean = false;
  @Output() onNext = new EventEmitter();

  subscription!: Subscription;

  constructor(private stepperService: StepperService) {
    this.subscription = this.stepperService.stepperState.subscribe({
      next: (state: number) => {
        this.currentStep = state;
      },
    });
  }

  ngAfterContentInit() {
    this.steps = this.stepsContent.map((content, index) => ({
      label: this.labels[index],
      content: content,
    }));
    this.buttonLayout = this.buttonContent.map((content, index) => ({
      label: 'Buttons',
      content: content,
    }));
    this.stepperService.totalSteps = this.steps.length;
  }

  goToStep(index: number) {
    this.currentStep = index;
  }
}
